var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemberTabWorkouts({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M385.95,101.92h254.81c28.15-.14,50.85-23.06,50.72-51.21-.14-27.95-22.76-50.58-50.72-50.72h-254.81c-28.15.14-50.85,23.06-50.72,51.21.14,27.95,22.76,50.58,50.72,50.72Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M833.74,56.06h-92.41c.4,4.52.4,9.07,0,13.59v10.87c0,42.22-34.22,76.44-76.44,76.44h-305.77c-42.22,0-76.44-34.22-76.44-76.44v-10.87c-.4-4.52-.4-9.07,0-13.59h-76.44c-56.29,0-101.92,45.63-101.92,101.92h0v764.09c0,56.29,45.63,101.92,101.92,101.93h611.55c56.29,0,101.92-45.63,101.92-101.92h0V143.03c0-47.64-38.32-86.42-85.96-86.98h0ZM704.3,805.54h-382.22c-21.11-1.99-36.61-20.72-34.62-41.83,1.73-18.35,16.26-32.89,34.62-34.62h382.22c21.11-1.99,39.84,13.51,41.83,34.62,1.99,21.11-13.51,39.84-34.62,41.83-2.4.23-4.81.23-7.21,0ZM704.3,609.17h-382.22c-21.11,1.99-39.84-13.51-41.83-34.62-1.99-21.11,13.51-39.84,34.62-41.83,2.4-.23,4.81-.23,7.21,0h382.22c21.11,1.99,36.61,20.72,34.62,41.83-1.73,18.35-16.26,32.89-34.62,34.62ZM704.3,412.79h-382.22c-21.11-1.99-36.61-20.72-34.62-41.83,1.73-18.35,16.26-32.89,34.62-34.62h382.22c21.11,0,38.22,17.11,38.22,38.22s-17.11,38.22-38.22,38.22Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberTabWorkouts);
export default __webpack_public_path__ + "static/media/member-tab-workouts.6c4f87673d9db417984bca45e717807b.svg";
export { ForwardRef as ReactComponent };